<template>
  <section v-bind:id="id" class="section">
    <h2>
      <i class="material-icons left">{{ iconName }}</i>
      {{ title }}
    </h2>

    <section class="section">
      <div class="row">
        <BaseTextInput
          v-bind="pisPasep"
          v-bind:disabled="readonly"
          v-bind:value="documentacaoExtra.pisPasep"
        />
      </div>
    </section>

    <section class="section">
      <h3>Identidade</h3>
      <div class="row">
        <BaseTextInput
          v-bind="carteiraIdentidade.numero"
          v-bind:disabled="readonly"
          v-bind:value="documentacaoExtra.carteiraIdentidade.numero"
        />
        <BaseTextInput
          v-bind="carteiraIdentidade.orgao"
          v-bind:disabled="readonly"
          v-bind:value="documentacaoExtra.carteiraIdentidade.orgao"
        />
        <BaseTextInput
          v-bind="carteiraIdentidade.uf"
          v-bind:disabled="readonly"
          v-bind:value="documentacaoExtra.carteiraIdentidade.uf"
        />
        <BaseTextInput
          v-bind="carteiraIdentidade.data"
          v-bind:disabled="readonly"
          v-bind:value="formattedCarteiraIdentidadeData"
        />
      </div>
    </section>

    <section class="section">
      <h3>Título de Eleitor</h3>
      <div class="row">
        <BaseTextInput
          v-bind="tituloEleitor.numero"
          v-bind:disabled="readonly"
          v-bind:value="documentacaoExtra.tituloEleitor.numero"
        />
        <BaseTextInput
          v-bind="tituloEleitor.zona"
          v-bind:disabled="readonly"
          v-bind:value="documentacaoExtra.tituloEleitor.zona"
        />
        <BaseTextInput
          v-bind="tituloEleitor.secao"
          v-bind:disabled="readonly"
          v-bind:value="documentacaoExtra.tituloEleitor.secao"
        />
        <BaseTextInput
          v-bind="tituloEleitor.uf"
          v-bind:disabled="readonly"
          v-bind:value="documentacaoExtra.tituloEleitor.uf"
        />
        <BaseTextInput
          v-bind="tituloEleitor.dataEmissao"
          v-bind:disabled="readonly"
          v-bind:value="formattedTituloEleitorDataEmissao"
        />
      </div>
    </section>

    <section class="section">
      <h3>Comprovante militar</h3>
      <div class="row">
        <BaseTextInput
          v-bind="comprovanteMilitar.numero"
          v-bind:disabled="readonly"
          v-bind:value="documentacaoExtra.comprovanteMilitar.numero"
        />
        <BaseTextInput
          v-bind="comprovanteMilitar.orgao"
          v-bind:disabled="readonly"
          v-bind:value="documentacaoExtra.comprovanteMilitar.orgao"
        />
        <BaseTextInput
          v-bind="comprovanteMilitar.serie"
          v-bind:disabled="readonly"
          v-bind:value="documentacaoExtra.comprovanteMilitar.serie"
        />
        <BaseTextInput
          v-bind="comprovanteMilitar.data"
          v-bind:disabled="readonly"
          v-bind:value="formattedComprovanteMilitarData"
        />
      </div>
    </section>

    <section class="section">
      <h3>Passaporte</h3>
      <div class="row">
        <BaseTextInput
          v-bind="passaporte.numero"
          v-bind:disabled="readonly"
          v-bind:value="documentacaoExtra.passaporte.numero"
        />
        <BaseTextInput
          v-bind="passaporte.orgao"
          v-bind:disabled="readonly"
          v-bind:value="documentacaoExtra.passaporte.orgao"
        />
        <BaseTextInput
          v-bind="passaporte.expedicao"
          v-bind:disabled="readonly"
          v-bind:value="formattedPassaporteExpedicao"
        />
        <BaseTextInput
          v-bind="passaporte.tipo"
          v-bind:disabled="readonly"
          v-bind:value="documentacaoExtra.passaporte.tipo"
        />
        <BaseTextInput
          v-bind="passaporte.vistoNumero"
          v-bind:disabled="readonly"
          v-bind:value="documentacaoExtra.passaporte.vistoNumero"
        />
        <BaseTextInput
          v-bind="passaporte.vistoValidade"
          v-bind:disabled="readonly"
          v-bind:value="formattedPassaporteVistoValidade"
        />
        <BaseTextInput
          v-bind="passaporte.vistoDuracaoMeses"
          v-bind:disabled="readonly"
          v-bind:value="documentacaoExtra.passaporte.vistoDuracaoMeses"
        />
        <BaseTextInput
          v-bind="passaporte.vistoTipo"
          v-bind:disabled="readonly"
          v-bind:value="documentacaoExtra.passaporte.vistoTipo"
        />
      </div>
    </section>
  </section>
</template>

<script>
export default {
  name: "DadosDocumentacao",
  inheritAttrs: false,
  props: {
    id: {
      type: String,
      required: true
    },

    title: String,
    iconName: String,

    documentacaoExtra: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      readonly: true,
      pisPasep: {
        id: this.buildElementId("pispasep"),
        label: "PIS/PASEP",
        gridExpression: "col s12 m6"
      },
      carteiraIdentidade: {
        numero: {
          id: this.buildElementId("identidade-numero"),
          label: "Número",
          gridExpression: "col s6"
        },
        orgao: {
          id: this.buildElementId("identidade-orgao"),
          label: "Órgão",
          gridExpression: "col s6"
        },
        uf: {
          id: this.buildElementId("identidade-uf"),
          label: "UF",
          gridExpression: "col s3"
        },
        data: {
          id: this.buildElementId("identidade-data"),
          label: "Data de expedição",
          gridExpression: "col s9"
        }
      },
      tituloEleitor: {
        numero: {
          id: this.buildElementId("eleitor-numero"),
          label: "Número",
          gridExpression: "col s12 m6"
        },
        zona: {
          id: this.buildElementId("eleitor-zona"),
          label: "Zona",
          gridExpression: "col s6 m3"
        },
        secao: {
          id: this.buildElementId("eleitor-secao"),
          label: "Seção",
          gridExpression: "col s6 m3"
        },
        uf: {
          id: this.buildElementId("eleitor-uf"),
          label: "UF",
          gridExpression: "col s3 m6"
        },
        dataEmissao: {
          id: this.buildElementId("eleitor-data"),
          label: "Data de emissão",
          gridExpression: "col s9 m6"
        }
      },
      comprovanteMilitar: {
        numero: {
          id: this.buildElementId("militar-numero"),
          label: "Número",
          gridExpression: "col s12 m6"
        },
        orgao: {
          id: this.buildElementId("militar-orgao"),
          label: "Órgão",
          gridExpression: "col s6 m3"
        },
        serie: {
          id: this.buildElementId("militar-serie"),
          label: "Série",
          gridExpression: "col s6 m3"
        },
        data: {
          id: this.buildElementId("militar-data"),
          label: "Data de emissão",
          gridExpression: "col s12 m6"
        }
      },
      passaporte: {
        numero: {
          id: this.buildElementId("passaporte-numero"),
          label: "Número",
          gridExpression: "col s12 m6"
        },
        orgao: {
          id: this.buildElementId("passaporte-orgao"),
          label: "Órgão",
          gridExpression: "col s12 m6"
        },
        expedicao: {
          id: this.buildElementId("passaporte-data"),
          label: "Data de expedição",
          gridExpression: "col s12 m6"
        },
        tipo: {
          id: this.buildElementId("passaporte-tipo"),
          label: "Tipo",
          gridExpression: "col s12 m3"
        },
        vistoNumero: {
          id: this.buildElementId("passaporte-visto-numero"),
          label: "Número do visto",
          gridExpression: "col s12 m6"
        },
        vistoValidade: {
          id: this.buildElementId("passaporte-visto-validade"),
          label: "Validade do visto",
          gridExpression: "col s12 m6"
        },
        vistoDuracaoMeses: {
          id: this.buildElementId("passaporte-visto-duracao"),
          label: "Duração do visto (meses)",
          gridExpression: "col s12 m6"
        },
        vistoTipo: {
          id: this.buildElementId("passaporte-visto-tipo"),
          label: "Tipo do visto",
          gridExpression: "col s12 m3"
        }
      }
    };
  },
  computed: {
    format() {
      return this.$utils.DateTime.format;
    },
    toBrazilianDate() {
      return this.$utils.DateTime.toBrazilianDate;
    },
    formattedCarteiraIdentidadeData() {
      return this.format(
        this.documentacaoExtra.carteiraIdentidade.data,
        this.toBrazilianDate
      );
    },
    formattedTituloEleitorDataEmissao() {
      return this.format(
        this.documentacaoExtra.tituloEleitor.dataEmissao,
        this.toBrazilianDate
      );
    },
    formattedComprovanteMilitarData() {
      return this.format(
        this.documentacaoExtra.comprovanteMilitar.data,
        this.toBrazilianDate
      );
    },
    formattedPassaporteExpedicao() {
      return this.format(
        this.documentacaoExtra.passaporte.expedicao,
        this.toBrazilianDate
      );
    },
    formattedPassaporteVistoValidade() {
      return this.format(
        this.documentacaoExtra.passaporte.vistoValidade,
        this.toBrazilianDate
      );
    }
  },
  methods: {
    buildElementId(name) {
      const id = this.id ? this.id : "dadosdocumentacao";
      return `${id}-${name}`;
    }
  }
};
</script>

<style scoped>
.row {
  margin-bottom: 0;
}
</style>
